module.exports = __webpack_public_path__ + "static/media/biwenjun.641c2154.png";